import { useAuth0 } from "@auth0/auth0-react";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import SearchAutoComplete from "components/SearchAutoComplete";
import SearchDownShift from "components/downmshift/DownShift";
import { useFormik } from "formik";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ToastHeader } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import NotAuthorized from "../../../../components/NotAuthorized";
import SettingHeader from "../../SettingHeader/settingHEader";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
const PaymentsTypes = ({ heading }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState("");
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [curruntId, setCurruntId] = useState(undefined);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState();
  const [paymentTypeData, setPaymentData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [IsSettingsActive, setIsSettingsActive] = useState(true);



  const formik = useFormik({
    enableReinitialize: true,
    initialValues:
      addNew === true
        ? {
            payement_type_new: "",
            default_payment_type: false,
            allow_member: false,
            coverConvenienceFee: false,
            optionalConvenienceFee: false,
            allowInstallment: false,
            allowMemberInstallment: false,
            convenienceFeeInfo: {
              amount: "",
              type: "%",
              ledger: {
                id: "",
                name: "",
              },
              subLedger: {
                id: "",
                name: "",
              }
            },
            

            optionalConvenienceFeeInfo: {

              optionalConvenienceFeeMessage: "",

            },
          }
        : {
            payement_type_new: paymentTypeData?.type ?? paymentTypes[0]?.type,
            default_payment_type:
              paymentTypeData?.is_default ?? paymentTypes[0]?.is_default,
            allow_member: paymentTypeData?.allow_member ?? paymentTypes[0]?.allow_member ?? false,
              coverConvenienceFee: paymentTypeData?.coverConvenienceFee ?? paymentTypes[0]?.coverConvenienceFee ?? false,
                 optionalConvenienceFee:

              paymentTypeData?.convenienceFeeInfo?.optional ??
              paymentTypes[0]?.convenienceFeeInfo?.optional ??

              false,
              allowInstallment: paymentTypeData?.allowInstallment ?? paymentTypes[0]?.allowInstallment,
              allowMemberInstallment: paymentTypeData?.allowMemberInstallment ?? paymentTypes[0]?.allowMemberInstallment,
              convenienceFeeInfo: {
                amount: paymentTypeData?.convenienceFeeInfo?.amount ?? paymentTypes[0]?.convenienceFeeInfo?.amount ?? "",
                type: paymentTypeData?.convenienceFeeInfo?.type ?? paymentTypes[0]?.convenienceFeeInfo?.type ?? "%",
                ledger: paymentTypeData?.convenienceFeeInfo?.ledger ?? paymentTypes[0]?.convenienceFeeInfo?.ledger ?? {
                  id: "",
                  name: "",
                },
                subLedger: paymentTypeData?.convenienceFeeInfo?.subLedger ?? paymentTypes[0]?.convenienceFeeInfo?.subLedger ?? {
                  id: "",
                  name: "",
                }
              },
                 optionalConvenienceFeeInfo: {

              optionalConvenienceFeeMessage:

                paymentTypeData?.convenienceFeeInfo?.message ??

                paymentTypes[0]?.convenienceFeeInfo?.message ??

                "",

            },
              paymentGateway: paymentTypeData?.paymentGateway ?? paymentTypes[0]?.paymentGateway ?? {},
          },
  });


  const getPaymentTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAllPaymentTypes(token)
      .then((res) => {
        const filteredData = res?.result?.map((item) => {
          return {
            ...item,
            paymentGateway: item?.paymentGateway?.title ? {
              value: item?.paymentGateway?.title,
              label: item?.paymentGateway?.title,
              provider: item?.paymentGateway?.provider,
            } : {},
          }
        })
        setPaymentTypes(filteredData);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const getpaymentById = async (type, id) => {
    setType(type);
    setCurruntId(id);
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getPaymentTypeById(token, id)
      .then((res) => {
        const filteredData = {
          ...res?.result,
          paymentGateway: res?.result?.paymentGateway?.title ? {
            value: res?.result?.paymentGateway?.title,
            label: res?.result?.paymentGateway?.title,
            provider: res?.result?.paymentGateway?.provider,
          } : {},
        }
        setPaymentData(filteredData)
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const disablePaymentType = async (type, id) => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.deletePaymentTypeById(
      token,
      curruntId ?? paymentTypes[0]?._id
    )
      .then(() => {
        toastr.success("success");
        getPaymentTypes();
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
    initialStage();
  };
  const option2 = paymentTypes?.map((item, index) => ({
    id: item?._id,
    name: item?.title ?? item?.type,
  }));


  
  const newPaymentType = async () => {
    
  
    if (
      formik.values?.payement_type_new == "" ||
      !formik.values?.payement_type_new.match(
        /^(?![\s-])[\w\s-]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid Payment Types");
    } else {
      const token = await getAccessTokenSilently();
      const payload = {
        type: formik.values?.payement_type_new,
        is_default: formik.values?.default_payment_type,
        allow_member: formik?.values?.allow_member,
        coverConvenienceFee: formik?.values?.coverConvenienceFee,
          optionalConvenienceFee:

          formik?.values?.coverConvenienceFee === true

            ? formik?.values?.optionalConvenienceFee

            : undefined,
        allowInstallment: formik?.values?.allowInstallment,
        allowMemberInstallment: formik?.values?.allowMember,
      }
      if(formik?.values?.coverConvenienceFee) {
        payload.convenienceFeeInfo = {
          amount: formik?.values?.convenienceFeeInfo?.amount,
          type: formik?.values?.convenienceFeeInfo?.type,
          ledger: formik?.values?.convenienceFeeInfo?.ledger,
        optionalConvenienceFee: formik?.values?.optionalConvenienceFee,
        }
            if (formik?.values?.optionalConvenienceFee) {

          const optionalConvenienceFeeMessage =

            formik?.values?.optionalConvenienceFeeMessage;

        

          payload.optionalConvenienceFeeInfo = {

            optionalConvenienceFeeMessage,

          };}
        if(formik?.values?.convenienceFeeInfo?.subLedger?.id) {
          payload.convenienceFeeInfo.subLedger = formik?.values?.convenienceFeeInfo?.subLedger
        }
      }
      await FinanceSettingService.createNewPaymentType(
        payload,
        token
      )
        .then(() => {
          toastr.success("Success", "New Type has been created");
          getPaymentTypes();
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
      push({
        pathname: "/financial-setting/payment-types/view",
      });
    }
  };
  const initialStage = () => {
    formik.setFieldValue("payement_type_new", paymentTypes[0]?.type);
    formik.setFieldValue("default_payment_type", paymentTypes[0]?.is_default);
    formik.setFieldValue("allow_member", paymentTypes?.[0]?.allow_member ?? false);
    formik.setFieldValue("coverConvenienceFee", paymentTypes?.[0]?.coverConvenienceFee ?? false);
      formik.setFieldValue(

      "optionalConvenienceFee",

      paymentTypes?.[0]?.convenienceFeeInfo?.optional ?? false

    );

    formik.setFieldValue(

      "optionalConvenienceFeeInfo.optionalConvenienceFeeMessage",

      paymentTypes?.[0]?.convenienceFeeInfo?.message ?? ""

    );
    formik.setFieldValue("allowInstallment", paymentTypes?.[0]?.allowInstallment ?? false);
    formik.setFieldValue("allowMemberInstallment", paymentTypes?.[0]?.allowMemberInstallment ?? false);
    formik.setFieldValue("convenienceFeeInfo.amount", paymentTypes?.[0]?.convenienceFeeInfo?.amount ?? "");
    formik.setFieldValue("convenienceFeeInfo.type", paymentTypes?.[0]?.convenienceFeeInfo?.type ?? "%");
    formik.setFieldValue("convenienceFeeInfo.ledger", paymentTypes?.[0]?.convenienceFeeInfo?.ledger ?? {
      id: "",
      name: "",
    });
    formik.setFieldValue("convenienceFeeInfo.subLedger", paymentTypes?.[0]?.convenienceFeeInfo?.subLedger ?? {
      id: "",
      name: "",
    });
    formik.setFieldValue("paymentGateway", paymentTypes?.[0]?.paymentGateway ?? {});
  };
  const updatePaymentById = async (data) => {
    if (
      formik.values?.payement_type_new == "" ||
      !formik.values?.payement_type_new.match(
        /^(?![\s-])[\w\s-]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid Payment Types");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.updatePaymentTypeById(
        token,
        curruntId ?? paymentTypes[0]?._id,
        data
        // {
        //   is_default: formik.values?.default_payment_type,
        // }
      )
        .then((res) => {
          getPaymentTypes();

          toastr.success("success", "Updated Successfully");
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
      // initialStage();
        if (curruntId) {
    await getpaymentById(type, curruntId);
  }
      push({
        pathname: "/financial-setting/payment-types/view",
      });
    }
  };
  useEffect(() => {
    getPaymentTypes();
  }, []);

  const { pathname } = useLocation();
  const { push } = useHistory();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);
  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue) {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.searchPaymentType(searchValue, token).then(
          (res) => {
            setPaymentTypes(res.result);
          }
        );
      }
    }, 1000),
    [searchValue]
  );

  useEffect(() => {
    if (searchValue === "") {
      getPaymentTypes();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);
  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);
  return IsSettingsActive == false ? (
    <NotAuthorized title={"Payment Types"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/payment-types/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">
      <div className="col-md-4 mb-5 pl-7 pr-7">
        <SearchDownShift
          items={option2}
          name={searchValue}
          setName={setSearchValue}
          placeHolder="Search"
          autoFocus
        />
      </div>
      <div className="setting-main">
        <div className="left-menu-div">
          <LeftMenu
            types={paymentTypes}
            btnText={"New Payment Type"}
            getTypeId={getpaymentById}
            disableAddNew={disableAddNew}
            setAddNew={setAddNew}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            addPath={addPath}
          />
        </div>
        <div className="settings-details">
          <ComponentHeading
            type={formik.values?.payement_type_new ?? type}
            id={curruntId}
            heading={heading}
            disable={disable}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            edit={edit}
            addNew={addNew}
            setEdit={setEdit}
            setAddPath={setAddPath}
            updateFunc={updatePaymentById}
            createFunc={newPaymentType}
            formik={formik}
            deleteFunc={disablePaymentType}
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default PaymentsTypes;
